import axios from 'axios'

// ACTION TYPES
const name = 'data'
export const actionTypes = {
  LOAD_FUND_DATA: `${name}:load_fund_data`,
  SET_SORT: `${name}:set_sort`,
  SET_LEVEL: `${name}:set_level`
}

// ACTIONS
export function loadFundData() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: getState().params.apiURL + '/funds/'
      // url: './sampleData.json'
    };
    return axios(request)
      .then(response => {
        let fundData = enrichFundData(response.data);
        dispatch({ type: actionTypes.LOAD_FUND_DATA, value: fundData });
        console.log(fundData);
      })
      .catch(error => {
        console.log(error)
      });
  }
}

export function setSort(column) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SORT, column: column });
  }
}

export function setLevel(level) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_LEVEL, value: level });
  }
}

// HELPER FUNCTIONS
function enrichFundData(funds) {
  return funds.map(fund => {
    fund['morningStarDate'] = fund.morningStarScorecard[0].date;
    //console.log(fund['morningStarDate']);
    // fund['morningStarCategory'] = (fund['morningStarCategory'].slice(7));
    fund['mstarRatOverall'] = 0;
    fund['mstarRatYrs03'] = 0;
    fund['mstarRatYrs05'] = 0;
    fund['mstarRatYrs10'] = 0;
    fund['numberOfInvestmentsOverall'] = 0;
    fund['numberOfInvestmentsYrs03'] = 0;
    fund['numberOfInvestmentsYrs05'] = 0;
    fund['numberOfInvestmentsYrs10'] = 0;
    fund['esgRating'] = 0;

    let keys = fund.morningStarScorecard[0].keys;
    let values = fund.morningStarScorecard[0].values;
    for (var x = 0; x < keys.length; x++) {
      fund[keys[x]] = values[x];
    }
    return fund;
  });
}




// WEBPACK FOOTER //
// ./src/actions/data.js